import { api } from "./Api";
import { establishmentQuery } from "./selectedEstablishment";

const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

/** Janela de apuração da missão */
export type MissionPeriod = "weekly" | "monthly" | "streak_4w";

/** Tipo da recompensa concedida */
export type RewardType =
  | "push_bonus"
  | "discount_percent"
  | "free_banner"
  | "badge";

export interface IMission {
  id: string;
  code: string;
  name: string;
  description: string | null;
  period: MissionPeriod;

  /** Quanto já foi acumulado no período */
  current: number;
  /** Meta a atingir */
  target: number;
  /** 0 a 100, pronto para a barra de progresso */
  percent: number;
  completed: boolean;

  reward: { type: RewardType; value: number };

  /** Quando o período corrente termina */
  periodEnd: string | null;
}

export interface IMissionRewards {
  /** Disparos extras já conquistados e ainda válidos */
  pushBonusAvailable: number;
  /** Teto mensal de disparos extras, somando todas as missões */
  pushBonusCap: number;
  freeBanners: number;
  /** Percentual de desconto conquistado e ainda não aplicado */
  pendingDiscount: number | null;
}

export interface IRestMissions {
  data: {
    code: number;
    message: string;
    data: { missions: IMission[]; rewards: IMissionRewards | null };
  };
}

/** Missões e progresso do estabelecimento selecionado no painel */
export const getMissions = () =>
  api.get(`/pt_BR/establishment/missions${establishmentQuery()}`, authHeader());